var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('HeaderHome'),_c('FormacionesHeader'),(_vm.getCursosFechaMes.length > 0)?_c('CursosHeader'):_vm._e(),_c('NuestrosExpertos'),_c('UsuariosPremium'),_c('SimpleFooterForum')],1)}
var staticRenderFns = []

export { render, staticRenderFns }